module.exports = __webpack_public_path__ + "img/kenwood.e2becaf6.png";